




































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class FlowNavigationPath extends Vue {
  @Prop()
  path: any;
  
  @Prop()
  paths: any[];

  @Prop()
  ruleStatus: string;

  @Prop()
  ruleIndex: number;

  @Prop()
  pathIndex: number;

  @Emit('select')
  onSelect() {}

  get pathWeigth() {
    return this.paths
      .filter((item) => item.status !== 'inactive')
      .map((item) => +item.weight)
      .reduce((a: number, b: number) => a + b, 0);
  }

  get pathName() {
    const name = this.path.name.replace('Path',this.t('Path'));
    return  `${name} (# ${this.pathIndex + 1})`
  }

  get percentName() {
    const result = this.pathWeigth !== 0 
      ? (this.path.weight * 100) / this.pathWeigth
      : 0;

    return `${this.path.weight} (${Math.round(result)}%)`;
  }
}
